import { Box, Paper, Typography } from "@mui/material";

export const SearchContainer = ({
  children,
  title,
}: {
  children: JSX.Element;
  title: string;
}) => {
  return (
    <Paper
      elevation={3}
      sx={{
        p: "15px",
        backgroundColor: "#eaeff1",
        borderRadius: "10px",
      }}
    >
      <Box sx={{ mb: "5px" }}>
        <Typography variant="h6">{title}</Typography>
        {/* <Divider /> */}
      </Box>
      <Box>{children}</Box>
    </Paper>
  );
};
